import React, { useState } from 'react';
import { useHistory } from "react-router";
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles,withStyles ,createStyles} from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Grid,
  Chip,
  FormControl,
  RadioGroup,
  Button,
  FormControlLabel,
  Radio,
  FormGroup
} from '@material-ui/core';
import { AdjustmentService } from '../../../services';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CustomDialog from '../../../components/Notifications/Dialog';
import NotiAdjustmentData from '../NotiAdjustmentData';
//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    //minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  success:{
    backgroundColor:theme.palette.success.main
  }
}));

const NotiAdjustmentTable = props => {
  const { className, dataTable_Adjustment, onChangeOrderBy, onChangePage, onChangeTable,loader,length,onSelectRow, ...rest } = props;

  const history = useHistory();
  // const classes = useStyles();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('EmployeeCode');
  const [itemSelect,setItemSelect] = useState(null);
  const [isOpenViewFileComplete,setIsOpenViewFileComplete] = useState(false);

  const handlePageChange = (event, _page) => {
    setPage(_page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    let dir = property!== orderBy?order: order==='asc'?'desc':'asc';
    setOrder(dir)
    setOrderBy(property)
    dataTable_Adjustment.sort(compareValues(property, dir))
  };

  const handleSelectRow = (property, obj) => {
    if(onSelectRow)
    {
      onSelectRow(property, obj);
    }
  };

  function compareValues(key, order = 'asc') {
    return function innerSort(a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
  
      const varA = (typeof a[key] === 'string')
        ? a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string')
        ? b[key].toUpperCase() : b[key];
  
      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  const handlerEditClick = (index, adjustmentId) => {
    history.push(`/NotiAdjustmentDetail/${adjustmentId}`);
  };

  const handleViewFile = (item) => {
    setItemSelect({...item});
    setIsOpenViewFileComplete(true)

    console.log(item)
  };

  const handleOnPrintHasHeader = () => {

    console.log('handleOnPrintHasHeader',itemSelect)
    if(itemSelect.status === 'BCFM'|| itemSelect.status == "ACCEPT" || itemSelect.status == "COMPLETE")
    {
        AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'fine_adjust',
        'filename':itemSelect.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(itemSelect.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(itemSelect.mom_no)
        ,'template': 'adjustment','body':'','title':''}).then((response)=>{
          setIsOpenViewFileComplete(false);
            setIsOpenViewFileComplete(false)
        });
    }else{
      AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'fine_adjust',
      'filename':itemSelect.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(itemSelect.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(itemSelect.mom_no)
      ,'template':'adjustment_draft','body':'','title':''}).then((response)=>{
        setIsOpenViewFileComplete(false);
          setIsOpenViewFileComplete(false)
      });
    }

  }
  const handleOnPrintNoneHeader= () => {


    console.log('handleOnPrintNoneHeader',itemSelect)

    if(itemSelect.status === 'BCFM'|| itemSelect.status == "ACCEPT" || itemSelect.status == "COMPLETE")
    {
      AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'fine_adjust',
      'filename':itemSelect.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(itemSelect.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(itemSelect.mom_no)
                ,'template':'adjustment_none_header','body':'','title':''}).then((response)=>{
                  setIsOpenViewFileComplete(false);
                    //setOpenLoading(false)
                });
    }else{
     
        AdjustmentService.getCreatePDFAdjustmentDetail({'id':itemSelect.adjustment_id,'type':'fine_adjust',
        'filename':itemSelect.product_type === 'C' ? NotiAdjustmentData.fileNameNotiAdjustment_C(itemSelect.mom_no) : NotiAdjustmentData.fileNameNotiAdjustment_G(itemSelect.mom_no)
                  ,'template':'adjustment_draft_none_header','body':'','title':''}).then((response)=>{
                    setIsOpenViewFileComplete(false);
                      //setOpenLoading(false)
                  });
      
    }
    
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table className="sp-table table rrs-table">
          <TableHead>
            <TableRow className="sp-table-header">
              <TableCell className="th-table text-center" style={{ width: 50 }}>PO/Contract No.
              </TableCell>
              <TableCell className="th-table text-center" style={{ width: 100 }}>งวดที่
                </TableCell>
              <TableCell className="th-table text-center" >Header
                Text</TableCell>
              <TableCell className="th-table text-center" style={{ width: 200 }}>Create
                By</TableCell>
              <TableCell className="th-table text-center" style={{ width: 50 }}>Create
                Date</TableCell>
              <TableCell className="th-table text-center"
                style={{ width: 150 }}>Status</TableCell>
              <TableCell className="th-table text-center"
                style={{ width: 50 }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              dataTable_Adjustment ? (
                dataTable_Adjustment.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((data, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className="text-center">{data.po_contract_no}</TableCell>
                        <TableCell className="text-center">{data.installment_no}</TableCell>
                        <TableCell className="text-left">{data.po_header_text}</TableCell>
                        <TableCell className="text-left">{data.create_by} {data.create_by_name}</TableCell>
                        <TableCell className="text-center">{data.create_date ? moment(data.create_date).format('DD/MM/YYYY') : ''}</TableCell>
                        <TableCell className="text-center">{data.status_name}</TableCell>
                        <TableCell className="text-center" style={{ display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                          <a onClick={() => handlerEditClick(index, data.adjustment_id)}
                            style={{ cursor: 'pointer', }} >
                            <i className="icon icon-preview-eye-blue" />
                          </a>

                          <a onClick={()=>handleViewFile(data)}
                            style={{ cursor: 'pointer', marginLeft: 10 }}>
                            <i className="icon icon-preview-pdf" />
                          </a>
                        </TableCell>
                      </TableRow>
                    )
                  })) : (
                <TableRow key={0}>
                  <TableCell colSpan="11" className="text-center" style={{
                    textAlign: 'center',
                    fontStyle: 'italic',
                    color: 'gray',
                  }}>No data</TableCell>
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        <TablePagination
          component="div"
          count={dataTable_Adjustment ? dataTable_Adjustment.length : 0 }
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[2, 5, 10, 25]}
        />
      </Grid>
      <Grid item>
        <CustomDialog open={isOpenViewFileComplete} title={"Print หนังสือเกี่ยวข้องกับการปรับ"} maxWidth="sm"
                onClose={()=>{
                    setIsOpenViewFileComplete(false)
                }}
                >
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} md={6} style={{textAlign:'center'}}>
                            <Button color="primary" variant={"contained"} style={{marginRight:5}} size="large"onClick={handleOnPrintHasHeader}>แบบมี Header/Footer</Button>
                            
                        </Grid>
                        <Grid item xs={12} md={6} style={{textAlign:'center'}}>
                            <Button color="primary" variant={"contained"} size="large" onClick={handleOnPrintNoneHeader}>แบบไม่มี Header/Footer</Button>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                       
                        <Grid>
                        {/* {itemSelect && itemSelect.status !== 'COMPLELE' && <Typography  color='secondary'>{"ใบงานยังไม่ Complete สามารถพิมพ์ได้เฉพาะไฟล์ตัวอย่าง"}</Typography>} */}
                        </Grid>
                    </Grid>
                </CustomDialog>
      </Grid>
    </Grid>
  );
};

NotiAdjustmentTable.propTypes = {
  className: PropTypes.string,
  dataTable_Adjustment: PropTypes.array.isRequired
};

export default NotiAdjustmentTable;




